module.exports = __webpack_public_path__ + "static/media/speech-path.b0971cee.jpg";